<template>
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 20C31.0807 18.1614 29.2015 17 27.1459 17H26M20 32C20.9193 33.8386 22.7985 35 24.8541 35H26M26 35H27.5898C29.3475 35 30.928 33.9299 31.5808 32.298C32.5789 29.8027 31.0681 27.0136 28.4328 26.4866L23.5672 25.5134C20.9319 24.9864 19.4211 22.1973 20.4192 19.7021C21.072 18.0701 22.6525 17 24.4102 17H26M26 35V38M26 17V14"
      stroke="var(--sf-illustration-primary-background-primary)"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.6667 15.3333C27.6452 13.2904 25.5572 12 23.2732 12H22M15.3333 28.6667C16.3548 30.7095 18.4428 32 20.7268 32H22M22 32H23.7664C25.7194 32 27.4756 30.811 28.2009 28.9977C29.3099 26.2252 27.6312 23.1262 24.7031 22.5406L19.2969 21.4594C16.3687 20.8737 14.6901 17.7748 15.7991 15.0023C16.5244 13.189 18.2806 12 20.2336 12H22M22 32V35.3333M22 12V8.66666"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
